import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlatformEnum } from '@panamax/app-state';
import { ProductConversionContainer } from '../../../models/product-conversion.model';
import { QuantityUpdate } from '../../../models/quantity-update';
import { ProductClickData } from '../../../models/usf-product-card.model';
import { ProductDetailViewModel } from '@product-detail/models/product-detail-view-model';

@Component({
  selector: 'app-product-conversion-container',
  templateUrl: './product-conversion-container.component.html',
  styleUrls: ['./product-conversion-container.component.scss'],
})
export class ProductConversionContainerComponent {
  @Input() platform: PlatformEnum;
  @Input() isOnline: boolean;
  @Input() productConversionContainers: ProductConversionContainer[];
  @Input() showAcceptDeclineButtons: boolean;
  @Input() originalProductTitle: string;
  @Input() pricingDisabled: boolean;

  @Output() changeQuantityEmitter = new EventEmitter<any>();
  @Output() acceptSwapEmitter = new EventEmitter<ProductConversionContainer>();
  @Output() declineSwapEmitter = new EventEmitter<ProductConversionContainer>();
  @Output()
  productImageClickEmitter: EventEmitter<ProductClickData> = new EventEmitter();
  @Output() compareClickEmitter =
    new EventEmitter<ProductConversionContainer>();

  readonly PlatformEnum = PlatformEnum;

  constructor() {}

  trackItem(index: any, item: ProductConversionContainer) {
    return item
      ? item?.originalProduct?.productNumber +
          '-' +
          item?.replacementProduct?.productNumber
      : index;
  }

  changeQuantityHandler(
    event: QuantityUpdate,
    productConversionContainer: ProductConversionContainer,
  ) {
    const quantityHandler = {
      quantityUpdate: event,
      productConversionContainer,
    };
    this.changeQuantityEmitter.emit(quantityHandler);
  }

  goToCompareProducts(productConversionContainer: ProductConversionContainer) {
    this.compareClickEmitter.emit(productConversionContainer);
  }

  acceptSwap(productConversionContainer: ProductConversionContainer) {
    this.acceptSwapEmitter.emit(productConversionContainer);
  }

  declineSwap(productConversionContainer: ProductConversionContainer) {
    this.declineSwapEmitter.emit(productConversionContainer);
  }

  handleProductImageClick(
    product: ProductDetailViewModel,
    currentProduct?: boolean,
  ) {
    this.productImageClickEmitter.emit({
      productNumber: product.productNumber,
      product,
      isQuickView: false,
      currentProduct,
    });
  }
}
